import { useEffect } from "react";

const SITE = "Fly Jannah Tours & Travels";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const usePageMeta = ({ title, description, image, type = "website" }) => {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} | Hajj & Umrah Packages from Bangladesh`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("name", "title", full);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", window.location.href);
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `https://fly-jannah.com${window.location.pathname}`);
  }, [title, description, image, type]);
};
